import { Result } from '@standardnotes/domain-core';
import { ComponentArea, NativeFeatureIdentifier } from '@standardnotes/features';
import { PrefKey } from '@standardnotes/models';
export class GetDefaultEditorIdentifier {
    constructor(preferences, items) {
        this.preferences = preferences;
        this.items = items;
    }
    execute(currentTag) {
        var _a;
        if (currentTag) {
            const editorIdentifier = (_a = currentTag === null || currentTag === void 0 ? void 0 : currentTag.preferences) === null || _a === void 0 ? void 0 : _a.editorIdentifier;
            if (editorIdentifier) {
                return Result.ok(editorIdentifier);
            }
        }
        const preferenceValue = this.preferences.getValue(PrefKey.DefaultEditorIdentifier);
        if (preferenceValue) {
            return Result.ok(preferenceValue);
        }
        const editors = this.thirdPartyComponentsForArea(ComponentArea.Editor);
        const matchingEditor = editors.filter((e) => e.legacyIsDefaultEditor())[0];
        if (matchingEditor) {
            return Result.ok(matchingEditor.identifier);
        }
        return Result.ok(NativeFeatureIdentifier.TYPES.PlainEditor);
    }
    thirdPartyComponentsForArea(area) {
        return this.items.getDisplayableComponents().filter((component) => {
            return component.area === area;
        });
    }
}
